import cancel from '../../assets/icons/color-cancel.svg';

export default { color: { cancel } };
